// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<p class=\"brec-feedback brec-feedback--info portal-text--estimated-bill-no-guarantee\"\n      data-test-estimated-bill-no-guarantee>\n  "
    + container.escapeExpression((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"estimated.bill.noGuarantee",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":3,"column":2},"end":{"line":3,"column":39}}}))
    + "\n</p>\n<span inject='estimated-bills'></span>";
},"useData":true});
